module.exports = __webpack_public_path__ + "img/mood_lauth.aae75766.png";